export class Type {
    id?: number
    name?: string

    constructor(object: any){
        this.id = object.typeId;
        this.name = object.typeName;
    }
}